import { ContainerModule, interfaces } from 'inversify';
import { ErrorsService, IErrorsService } from './errors.service';
import { ErrorsStore, IErrorsStore } from './errors.store';

export const errorsModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IErrorsStore.$).to(ErrorsStore).inSingletonScope();
  bind(IErrorsService.$).to(ErrorsService).inSingletonScope();
});
